
import { create } from 'zustand';

export enum EnumModals {
    HistoricoPedidos,
    ResumoPedido
}


interface IModalStore {
    modals: { codigo: EnumModals, aberto: boolean, props: any }[];
    openCloseModal<T = any>(codigo: EnumModals, aberto?: boolean, props?: T): void;
}

/*
Criei esse store pra abrir modais, porém só estou usando em modais novos,
 não mexi ainda na lógica ainda com receio de quebrar algo
*/
export const useModalStore = create<IModalStore>()(
    (set, get) => ({
        modals: [
            {
                aberto: false,
                codigo: EnumModals.HistoricoPedidos,
                props: {},
            },
            {
                aberto: false,
                codigo: EnumModals.ResumoPedido,
                props: {},
            }
        ],
        openCloseModal(codigo, aberto, props) {
            const objeto = get();
            const modal = objeto.modals.find(x => x.codigo === codigo);
            if (modal) {
                const index = objeto.modals.indexOf(modal);
                if (props) {
                    objeto.modals[index].props = props;
                }
                if (typeof aberto === 'boolean') {
                    objeto.modals[index].aberto = aberto;
                } else {
                    objeto.modals[index].aberto = !objeto.modals[index].aberto
                    return objeto;
                }
            }
            set((state) => ({
                ...state,
                modals: [...objeto.modals]
            }))
        },
    }),
);  